module.exports = __webpack_public_path__ + "img/Close.cb486c67.svg";